// extracted by mini-css-extract-plugin
module.exports = {"copy-code-container":"_37x-l","copyCodeContainer":"_37x-l"};